import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Building2, ShoppingCart, Package, User } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const mobileNavigation = [
  { name: 'Accueil', href: '/dashboard', icon: Home },
  { name: 'Chantiers', href: '/chantiers', icon: Building2 },
  { name: 'Ventes', href: '/ventes', icon: ShoppingCart },
  { name: 'Produits', href: '/products', icon: Package },
  { name: 'Profil', href: '/profile', icon: User },
];

function MobileNavigation() {
  const { canAccess } = useAuth();

  return (
    <div className="bg-white border-t border-gray-200">
      <div className="grid grid-cols-4 py-2">
        {mobileNavigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            className={({ isActive }) => `
              flex flex-col items-center py-2 px-1 text-xs font-medium transition-colors
              ${isActive 
                ? 'text-blue-600' 
                : 'text-gray-500 hover:text-gray-700'
              }
            `}
          >
            <item.icon className="h-5 w-5 mb-1" />
            {item.name}
          </NavLink>
        ))}
      </div>
    </div>
  );
}

export default MobileNavigation;